import React from 'react'
import { graphql } from 'gatsby'
import Img from 'gatsby-image'
import posed from 'react-pose'
import { TransitionState } from 'gatsby-plugin-transition-link'
import styled from 'styled-components'
import Page from '../components/page'
import CaseData from '../components/caseData'
import ItemGrid from '../components/itemGrid'
// import FeatureText from '../components/featureText'
// import Underlined from '../components/underlined'
import Intro from '../components/intro'
import EndSection from '../components/endSection'
// import FixedIndex from '../components/fixedIndex'
import Waypoint from 'react-waypoint'
import OverlapCarousel from '../components/overlapCarousel'
import FeatureText from '../components/featureText'
import Marking from '../components/marking'
import H3 from '../components/h3'
import MinecraftLegacyAnimation from '../components/minecraftLegacyAnimation'
import mmSnap from '../images/mm-snap.gif'
import mmScroll from '../images/mm-scroll.gif'
import Footer from '../components/footer'

const PageTransitionStates = {}

const casesTransitions = {
  // startState: {
  //   opacity: 1,
  // },
  // exitedState: {
  //   opacity: 1,
  //   transition: {
  //     duration: 300,
  //     ease: 'easeIn',
  //   },
  // },
  // visible: {
  //   opacity: 1,
  //   transition: {
  //     delay: 1500,
  //     duration: 300,
  //   },
  // },
}

const PageWithTransition = styled(posed.div(PageTransitionStates))`
  opacity: 1;
`

const FixedTop = styled.div`
  position: relative;
  z-index: 2;
  padding: 0 1rem;
  @media (max-height: 850px) {
    opacity: 1 !important;
  }
`

const Cases = styled(posed.div(casesTransitions))`
  margin-top: 15rem;
  padding: 0 1rem;
`

const CaseH2 = styled.h2`
  color: #d5d5d5;
  font-size: 80px;
  margin-bottom: 3rem;
  z-index: 2;
  position: relative;
  @media (max-width: 1250px) {
    font-size: 60px;
  }
  @media (max-width: 768px) {
    font-size: 50px;
  }
`

const Case = styled.div`
  max-width: 1650px;
  margin: 10rem auto;
`

const CaseMaxWidth = styled(Case)`
  max-width: none;
`

const CaseImg = styled(Img)`
  /* margin-bottom: 10rem; */
`

const HalfImage = styled(CaseImg)`
  width: 70%;
  @media (max-width: 768px) {
    width: 100%;
    margin: 1rem 0;
  }
`

const HalfImageSmaller = styled(CaseImg)`
  width: 50%;
  @media (max-width: 768px) {
    width: 100%;
    margin: 1rem 0;
  }
`

const SideText = styled.div`
  width: 30%;
  padding: 5rem 2rem 0 0rem;
  max-width: 300px;
  @media (max-width: 768px) {
    width: 90%;
    margin: 1rem 0;
    padding: 1rem 1rem;
  }
`

const SideTextNoTopPadding = styled(SideText)`
  padding: 0rem 2rem 0 0rem;
`

const CaseP = styled.p`
  color: #828282;
  font-size: 14px;
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  line-height: 1.45;
`

const TwoColumns = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  margin-bottom: 5rem;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`

const FullImage = styled.div`
  margin-bottom: 10rem;
`

const FullBleedImage = styled(FullImage)`
  margin-top: -10%;
  margin-right: -10%;
  margin-left: -10%;
  position: relative;
  @media (max-width: 768px) {
    margin-top: -90px;
    margin-right: -150%;
    margin-left: -40%;
  }
`

const GradientOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  z-index: 2;
  background: linear-gradient(
    to bottom,
    rgba(246, 247, 248, 0) 0%,
    rgba(246, 247, 248, 1) 100%
  ); /* W3C */
`

const TwoColumnsBlackSection = styled(TwoColumns)`
  background-color: black;
  width: 100vw;
  max-width: 100vw;
  padding: 7rem 0 6rem;
  align-items: flex-start;
  margin: 10rem calc(-50vw + 50%) 2rem;
`

const TwoColumnsSmallOffsetCardGrid = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-start;
  justify-content: space-between;
  margin-left: 5rem;
  margin-top: 10rem;
  margin-right: -10%;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: -10%;
    margin-left: -10%;
  }
`

const TwoColumnsReverse = styled(TwoColumns)`
  flex-direction: row-reverse;
`

const TwoColumnsMediumCenter = styled(TwoColumns)`
  width: 70%;
  margin: 0 auto;
  margin-bottom: 10rem;
  align-items: flex-start;
`

const TwoColumnsParagraphs = styled(TwoColumns)`
  width: 70%;
  margin: 0 auto;
  justify-content: flex-start;
`

const StartDescriptionWrap = styled.div`
  max-width: 1250px;
  margin: 0 auto 25rem;
  opacity: 0;
  padding: 0 1rem;
`

const StartDescription = styled.h5`
  color: #4f4f4f;
  font-weight: 600;
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  line-height: normal;
  font-size: 21px;
  width: 50%;
  @media (max-width: 1250px) {
    width: 40%;
  }
  @media (max-width: 768px) {
    width: 100%;
  }
`

const CaseTop = styled.div`
  padding: 0 0 10px;
  margin: 0 auto 75px;
  position: relative;
  max-width: 1400px;
`

const CaseTopBackground = styled.div`
  position: absolute;
  top: 42px;
  left: -100%;
  right: -100%;
  bottom: 0;
  background-color: white;
  box-shadow: 0 27px 15px -20px rgba(0, 0, 0, 0.07);
  @media (max-width: 768px) {
    top: 28px;
  }
`

const Emphasis = styled.span`
  color: #4f4f4f;
  position: relative;
  display: inline-block;
  white-space: nowrap;
  @media (max-width: 768px) {
    white-space: normal;
  }
`

const ComingSoon = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #999999;
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  line-height: 1.5;
  font-size: 18px;
  margin: -5rem 2rem 15rem;
  text-align: center;
`

const NavigationPrototypesContainer = styled.div`
  width: 50%;
  margin-right: 20%;
`

const H3White = styled.h2`
  color: #ffffff;
  font-size: 30px;
  font-weight: 700;
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica,
    'Segoe UI', Arial, sans-serif;
  @media (max-width: 768px) {
    font-size: 25px;
  }
`

const IntroWithRef = React.forwardRef((props, ref) => {
  return <Intro innerRef={ref} {...props} />
})

let lastScrollY = 0
let ticking = false

class IndexPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      logoStatus: 'startState',
      // scrollPosition: ['hiddenState', 'start'],
      scrollPosition: ['startState'],
      firstLine: 'startState',
      secondLine: 'startState',
      thirdLine: 'startState',
      fourthLine: 'startState',
      fifthLine: 'startState',
      sixthLine: 'startState',
      seventhLine: 'startState',
      eigthLine: 'startState',
    }
    // this.handleWaypointLeave = this.handleWaypointLeave.bind(this)
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll = () => {
    lastScrollY = window.scrollY
    if (!ticking) {
      window.requestAnimationFrame(() => {
        this.nav.current.style.opacity = `${1 - (lastScrollY / 100) * 0.3}`
        if (lastScrollY < 300) {
          this.subNav.current.style.opacity = 0
        } else {
          this.subNav.current.style.opacity = `${0 +
            ((lastScrollY - 300) / 100) * 0.5}`
        }
        ticking = false
      })

      ticking = true
    }
  }

  getTransitionStates(status) {
    if (['entering', 'entered'].includes(status)) {
      return ['visible', 'logoChain']
    } else if (['exiting'].includes(status)) {
      return 'exitedState'
    } else if (['exited'].includes(status)) {
      return 'startState'
    }
  }

  nav = React.createRef()
  subNav = React.createRef()

  handleWaypointEnter(position) {
    if (position === 'minecraft') {
      this.setState({
        firstLine: 'line',
      })
    } else if (position === 'minecraft2') {
      this.setState({
        secondLine: 'line',
      })
    } else if (position === 'speaking') {
      this.setState({
        thirdLine: 'line',
      })
    } else if (position === 'bandpage') {
      this.setState({
        fourthLine: 'line',
        fifthLine: 'lineDelayed',
      })
    } else if (position === 'sideprojects') {
      this.setState({
        sixthLine: 'line',
        seventhLine: 'lineDelayed',
        eigthLine: 'lineDelayedMore',
      })
    }
  }

  render() {
    return (
      <Page>
        <TransitionState>
          {({ transitionStatus: status }) => {
            return (
              <PageWithTransition
                pose={this.getTransitionStates(status)}
                initialPose={'startState'}
              >
                <Waypoint
                  // onLeave={}
                  onEnter={() => this.handleWaypointEnter('startState')}
                />
                <FixedTop ref={this.nav}>
                  <IntroWithRef
                    status={status}
                    profilePhoto={this.props.data.profilePhoto}
                  />
                </FixedTop>
                <StartDescriptionWrap ref={this.subNav}>
                  <StartDescription>
                    I love creating functional, sustainable and deeply human
                    technology products for a post-digital era. <br />
                    <br /> My design approach tend to include research,
                    interactive prototypes and close engineering collaboration
                    for pragmatic outcomes that stresses the details. <br />
                    <br />I thrive when following a technology and business case
                    all the way through to a delightful user experience.
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    On this page I will soon collect a selection of my work.
                  </StartDescription>
                </StartDescriptionWrap>
                {/* <Cases>
                  <CaseMaxWidth>
                    <StartDescriptionWrap ref={this.subNav}>
                      <StartDescription>
                        I love creating functional, sustainable and deeply human
                        technology products for a post-digital era. <br />
                        <br /> My design approach tend to include research,
                        interactive prototypes and close engineering
                        collaboration for pragmatic outcomes that stresses the
                        details. <br />
                        <br />I thrive when following a technology and business
                        case all the way through to a delightful user
                        experience.
                        <br />
                        <br />
                        On this page I've collected a selection of my work.
                      </StartDescription>
                    </StartDescriptionWrap>
                    <CaseTop>
                      <CaseH2>
                        Currently I'm making a UI design system for{' '}
                        <Emphasis>
                          Minecraft{' '}
                          <Marking markingStatus={this.state.firstLine} />
                        </Emphasis>
                      </CaseH2>
                      <CaseData
                        description="With 100M+ players around the world, how should a UI design system behave that scales across most device types and interaction methods, while keeping the expressive qualities of a game UI intact for the Minecraft design teams?"
                        year="2018 –"
                        roles="UX design, UI design, Design system and Design tools"
                      />
                      <CaseTopBackground />
                    </CaseTop>
                    <Waypoint
                      onEnter={() => this.handleWaypointEnter('minecraft')}
                    />
                    <FullBleedImage>
                      <GradientOverlay />
                      <Img
                        fluid={
                          this.props.data.minecraftDevices.childImageSharp.fluid
                        }
                      />
                    </FullBleedImage>
                    <ComingSoon>
                      <p>Work in progress. Stay tuned for an in-depth look.</p>
                      <p>
                        Feel free to bookmark my <a href="/writing">blog</a> or
                        follow me on{' '}
                        <a href="www.twitter.com/oscrse">Twitter</a> for
                        updates.
                      </p>
                    </ComingSoon>
                  </CaseMaxWidth>
                  <Case>
                    <CaseTop>
                      <CaseH2>
                        I also did concept UX design and interactive prototyping
                        of{' '}
                        <Emphasis>
                          Minecraft{' '}
                          <Marking markingStatus={this.state.secondLine} />
                        </Emphasis>{' '}
                        user interfaces
                      </CaseH2>
                      <CaseData
                        description="I was given the opportunity to elaborate on how future developments of the core interface patterns of Minecraft could evolve, to accomodate a growing number of services and functions for the players."
                        year="2017"
                        roles="UX design, Interactive prototyping"
                      />
                      <CaseTopBackground />
                    </CaseTop>
                    <Waypoint
                      onEnter={() => this.handleWaypointEnter('minecraft2')}
                    />
                    <FeatureText
                      quote="How can you evolve an established user interface for a game, to support a growing ecosystem of styles of playing?"
                      eyeBrow="Design challenge"
                    />
                    <TwoColumnsMediumCenter>
                      <MinecraftLegacyAnimation data={this.props.data} />
                      <SideTextNoTopPadding>
                        <CaseP>
                          Joining a newly formed UX team at Mojang in Stockholm,
                          Sweden, I started researching an approach to
                          reconsidering the main menu of the game.
                        </CaseP>
                        <CaseP>
                          Over the years prior, the minimal menu of Minecraft:
                          Pocket Edition had grown into a platform for many
                          services and functions related to the game, but the
                          main interaction model was staying the same – A static
                          layout of buttons.
                        </CaseP>
                        <CaseP>
                          At the same time, more platforms and screen sizes was
                          now supported, ranging from small phones to consoles
                          and TV-screens.
                        </CaseP>
                      </SideTextNoTopPadding>
                    </TwoColumnsMediumCenter>
                    <TwoColumnsSmallOffsetCardGrid>
                      <HalfImage
                        fluid={
                          this.props.data.minecraftWireframes.childImageSharp
                            .fluid
                        }
                      />
                      <SideTextNoTopPadding>
                        <H3>Hypothesis tree & Wireframing</H3>
                        <CaseP>
                          Starting with hypotheses for how this area of the game
                          should serve the players, sets of wireframes was
                          created to documents ideas of naviation, interaction
                          and features that could support these purposes.
                        </CaseP>
                        <CaseP>
                          Such redesigns were instigated as the startup's
                          audience shifted within the music management industry,
                          ranging from fan-serving products, to tools for indie
                          musicians and to record labels and managers.
                        </CaseP>
                      </SideTextNoTopPadding>
                    </TwoColumnsSmallOffsetCardGrid>
                    <TwoColumnsSmallOffsetCardGrid>
                      <NavigationPrototypesContainer>
                        <img alt="Prototype of snapping row UI" src={mmSnap} />
                        <img
                          alt="Prototype of scrolling horizontally and vertically"
                          src={mmScroll}
                        />
                      </NavigationPrototypesContainer>
                      <SideTextNoTopPadding>
                        <H3>Navigation prototypes</H3>
                        <CaseP>
                          Shown here is stages of redesign of the BandPage
                          landing page, featuring a new mobile onboarding with
                          more lucid communication and new value propositions.
                        </CaseP>
                        <CaseP>
                          Such redesigns were instigated as the startup's
                          audience shifted within the music management industry,
                          ranging from fan-serving products, to tools for indie
                          musicians and to record labels and managers.
                        </CaseP>
                      </SideTextNoTopPadding>
                    </TwoColumnsSmallOffsetCardGrid>
                    <TwoColumnsParagraphs>
                      <SideText>
                        <H3>Evaluating the concepts</H3>
                        <CaseP>
                          Shown here is stages of redesign of the BandPage
                          landing page, featuring a new mobile onboarding with
                          more lucid communication and new value propositions.
                        </CaseP>
                        <CaseP>
                          Such redesigns were instigated as the startup's
                          audience shifted within the music management industry,
                          ranging from fan-serving products, to tools for indie
                          musicians and to record labels and managers.
                        </CaseP>
                      </SideText>
                      <SideText>
                        <CaseP>
                          Shown here is stages of redesign of the BandPage
                          landing page, featuring a new mobile onboarding with
                          more lucid communication and new value propositions.
                        </CaseP>
                        <CaseP>
                          Such redesigns were instigated as the startup's
                          audience shifted within the music management industry,
                          ranging from fan-serving products, to tools for indie
                          musicians and to record labels and managers.
                        </CaseP>
                      </SideText>
                    </TwoColumnsParagraphs>
                  </Case>
                  <Case>
                    <CaseTop>
                      <CaseH2>
                        I’m speaking & leading workshops in{' '}
                        <Emphasis>
                          Prototyping and Innovation{' '}
                          <Marking
                            markingStatus={this.state.thirdLine}
                            alternative={true}
                          />
                        </Emphasis>{' '}
                        methods, based on research work from my M.Sc thesis
                      </CaseH2>
                      <CaseData
                        description="I my final year of design school I completed a Master's thesis about prototyping methods for interaction designers. Since then I have applied my framework in teaching design students and professionals. "
                        year="2017 –"
                        roles="Facilitator, Speaker"
                      />
                      <CaseTopBackground />
                    </CaseTop>
                    <Waypoint
                      onEnter={() => this.handleWaypointEnter('speaking')}
                    />
                    <OverlapCarousel data={this.props.data} />
                    <TwoColumnsSmallOffsetCardGrid>
                      <HalfImage
                        fluid={this.props.data.talk4.childImageSharp.fluid}
                      />
                      <SideText>
                        <H3>25 Principles</H3>
                        <CaseP>
                          Shown here is stages of redesign of the BandPage
                          landing page, featuring a new mobile onboarding with
                          more lucid communication and new value propositions.
                        </CaseP>
                        <CaseP>
                          Such redesigns were instigated as the startup's
                          audience shifted within the music management industry,
                          ranging from fan-serving products, to tools for indie
                          musicians and to record labels and managers.
                        </CaseP>
                      </SideText>
                    </TwoColumnsSmallOffsetCardGrid>
                  </Case>
                  <Case>
                    <CaseTop>
                      <CaseH2>
                        Previously, I did data science at{' '}
                        <Emphasis>
                          YouTube Music
                          <Marking markingStatus={this.state.fourthLine} />
                        </Emphasis>{' '}
                        and UX engineering at{' '}
                        <Emphasis>
                          BandPage
                          <Marking
                            markingStatus={this.state.fifthLine}
                            alternative={true}
                          />
                        </Emphasis>{' '}
                        (acquired by Google)
                      </CaseH2>
                      <CaseData
                        description="BandPage is a music software startup that enabled half a million artists to manage their data on the major music streaming services. Challenges included a fast paced evolving business that targeted multiple audiences within the dynamic music industry. Many product surface areas required complex UIs and a precise marketing site."
                        year="2015 – 2016"
                        roles="UI design, React UI Engineering"
                      />
                      <CaseTopBackground />
                    </CaseTop>
                    <Waypoint
                      onEnter={() => this.handleWaypointEnter('bandpage')}
                    />
                    <FeatureText
                      quote="How do you communicate & build tools that capture the value of metadata for the music industry?"
                      eyeBrow="Core design challenge"
                    />
                    <TwoColumnsReverse
                      style={{
                        paddingBottom: 5 + 'rem',
                        justifyContent: 'center',
                      }}
                    >
                      <HalfImageSmaller
                        fluid={
                          this.props.data.bpPhonesTwo.childImageSharp.fluid
                        }
                      />
                      <SideText>
                        <H3>Marketing site</H3>
                        <CaseP>
                          Shown here is stages of redesign of the BandPage
                          landing page, featuring a new mobile onboarding with
                          more lucid communication and new value propositions.
                        </CaseP>
                        <CaseP>
                          Such redesigns were instigated as the startup's
                          audience shifted within the music management industry,
                          ranging from fan-serving products, to tools for indie
                          musicians and to record labels and managers.
                        </CaseP>
                      </SideText>
                    </TwoColumnsReverse>
                    <TwoColumns style={{ justifyContent: 'center' }}>
                      <HalfImageSmaller
                        fluid={
                          this.props.data.bpNotification.childImageSharp.fluid
                        }
                      />
                      <SideText>
                        <H3>Designing and building data tools</H3>
                        <CaseP>
                          Shown here is stages of redesign of the BandPage
                          landing page, featuring a new mobile onboarding with
                          more lucid communication and new value propositions.
                        </CaseP>
                        <CaseP>
                          Such redesigns were instigated as the startup's
                          audience shifted within the music management industry,
                          ranging from fan-serving products, to tools for indie
                          musicians and to record labels and managers.
                        </CaseP>
                      </SideText>
                    </TwoColumns>
                    <TwoColumnsParagraphs>
                      <SideText>
                        <H3>BandPage Editor</H3>
                        <CaseP>
                          Shown here is stages of redesign of the BandPage
                          landing page, featuring a new mobile onboarding with
                          more lucid communication and new value propositions.
                        </CaseP>
                        <CaseP>
                          Such redesigns were instigated as the startup's
                          audience shifted within the music management industry,
                          ranging from fan-serving products, to tools for indie
                          musicians and to record labels and managers.
                        </CaseP>
                      </SideText>
                      <SideText>
                        <CaseP>
                          Shown here is stages of redesign of the BandPage
                          landing page, featuring a new mobile onboarding with
                          more lucid communication and new value propositions.
                        </CaseP>
                        <CaseP>
                          Such redesigns were instigated as the startup's
                          audience shifted within the music management industry,
                          ranging from fan-serving products, to tools for indie
                          musicians and to record labels and managers.
                        </CaseP>
                      </SideText>
                    </TwoColumnsParagraphs>

                    <FullImage
                      style={{
                        paddingTop: 5 + 'rem',
                        paddingLeft: 5 + 'rem',
                        paddingRight: 5 + 'rem',
                      }}
                    >
                      <Img
                        fluid={this.props.data.bpLaptop.childImageSharp.fluid}
                      />
                    </FullImage>
                    <TwoColumnsBlackSection>
                      <HalfImage
                        fluid={
                          this.props.data.bpPhonesThree.childImageSharp.fluid
                        }
                      />
                      <SideText style={{ paddingTop: 2 + 'rem' }}>
                        <H3White>Building in React</H3White>
                        <CaseP>
                          Shown here is stages of redesign of the BandPage
                          landing page, featuring a new mobile onboarding with
                          more lucid communication and new value propositions.
                        </CaseP>
                        <CaseP>
                          Such redesigns were instigated as the startup's
                          audience shifted within the music management industry,
                          ranging from fan-serving products, to tools for indie
                          musicians and to record labels and managers.
                        </CaseP>
                      </SideText>
                    </TwoColumnsBlackSection>
                    <TwoColumnsParagraphs>
                      <SideText>
                        <H3>YouTube Music</H3>
                        <CaseP>
                          Shown here is stages of redesign of the BandPage
                          landing page, featuring a new mobile onboarding with
                          more lucid communication and new value propositions.
                        </CaseP>
                        <CaseP>
                          Such redesigns were instigated as the startup's
                          audience shifted within the music management industry,
                          ranging from fan-serving products, to tools for indie
                          musicians and to record labels and managers.
                        </CaseP>
                      </SideText>
                      <SideText>
                        <CaseP>
                          Shown here is stages of redesign of the BandPage
                          landing page, featuring a new mobile onboarding with
                          more lucid communication and new value propositions.
                        </CaseP>
                        <CaseP>
                          Such redesigns were instigated as the startup's
                          audience shifted within the music management industry,
                          ranging from fan-serving products, to tools for indie
                          musicians and to record labels and managers.
                        </CaseP>
                      </SideText>
                    </TwoColumnsParagraphs>
                  </Case>
                  <Case>
                    <CaseTop>
                      <CaseH2>
                        Other projects include{' '}
                        <Emphasis>
                          woodworking
                          <Marking markingStatus={this.state.sixthLine} />
                        </Emphasis>
                        ,{' '}
                        <Emphasis>
                          VR/AR Prototyping
                          <Marking
                            markingStatus={this.state.seventhLine}
                            alternative={true}
                          />
                        </Emphasis>{' '}
                        and{' '}
                        <Emphasis>
                          Interactive experiments
                          <Marking markingStatus={this.state.eigthLine} />
                        </Emphasis>
                      </CaseH2>
                      <Waypoint
                        onEnter={() => this.handleWaypointEnter('sideprojects')}
                      />
                      <CaseData
                        description="BandPage is a music software startup that enabled half a million artists to manage their data on the major music streaming services. Challenges included a fast paced evolving business that targeted multiple audiences within the dynamic music industry. Many product surface areas required complex UIs and precise communication of service offerings."
                        year="2015 – 2016"
                        roles="UI design, React UI Engineering"
                      />
                      <CaseTopBackground />
                    </CaseTop>
                  </Case>
                </Cases> */}
                {/* <ItemGrid
                  imageOne={this.props.data.pixelLamp_1.childImageSharp.fluid}
                />
                <EndSection /> */}
                <Footer />
                {/* <FixedIndex position={this.state.scrollPosition} /> */}
                {/* <TransitionOverlay pose={getTransitionStates(status)} /> */}
              </PageWithTransition>
            )
          }}
        </TransitionState>
      </Page>
    )
  }
}

export default IndexPage

export const pageQuery = graphql`
  query {
    profilePhoto: file(relativePath: { eq: "profile-photo.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 500) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }

    minecraftswitch: file(relativePath: { eq: "minecraftswitch.png" }) {
      childImageSharp {
        fluid(maxWidth: 2560) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }

    minecraftDevices: file(relativePath: { eq: "Devices_nocrop.png" }) {
      childImageSharp {
        fluid(maxWidth: 2560) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    minecraftWireframes: file(relativePath: { eq: "wireframes.png" }) {
      childImageSharp {
        fluid(maxWidth: 2560) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }

    bpPhonesThree: file(relativePath: { eq: "bp-phones.png" }) {
      childImageSharp {
        fluid(maxWidth: 925) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }

    bpLaptop: file(relativePath: { eq: "bp1-macbook-2.png" }) {
      childImageSharp {
        fluid(maxWidth: 2560) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }

    bpPhonesTwo: file(relativePath: { eq: "bp-new-phones.png" }) {
      childImageSharp {
        fluid(maxWidth: 2560) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }

    bpNotification: file(relativePath: { eq: "bp_notification.png" }) {
      childImageSharp {
        fluid(maxWidth: 2560) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }

    bpApp: file(relativePath: { eq: "bp-editor-merch-update.png" }) {
      childImageSharp {
        fluid(maxWidth: 2560) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }

    hyper2: file(
      relativePath: { eq: "Hyper_Design_Lead_Prototyping.002.png" }
    ) {
      childImageSharp {
        fluid(maxWidth: 2560) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }

    talk2: file(relativePath: { eq: "Mindful.png" }) {
      childImageSharp {
        fluid(maxWidth: 2560) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }

    talk3: file(relativePath: { eq: "final_presentation_002.png" }) {
      childImageSharp {
        fluid(maxWidth: 2560) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }

    talk4: file(relativePath: { eq: "card_grid.png" }) {
      childImageSharp {
        fluid(maxWidth: 1440) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }

    hyper1_1: file(relativePath: { eq: "prototyping_hyper_IAD18.011.png" }) {
      childImageSharp {
        fluid(maxWidth: 2560) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }

    hyper1_2: file(relativePath: { eq: "prototyping_hyper_IAD18.002.png" }) {
      childImageSharp {
        fluid(maxWidth: 2560) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }

    hyper1_3: file(relativePath: { eq: "prototyping_hyper_IAD18.001.png" }) {
      childImageSharp {
        fluid(maxWidth: 2560) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }

    pixelLamp_1: file(relativePath: { eq: "pixel-5-tall.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 2560) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }

    pixelLamp_2: file(relativePath: { eq: "pixel-1.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 2560) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }

    minecraftLegacyFrame: file(relativePath: { eq: "mcFrame.png" }) {
      childImageSharp {
        fluid(maxWidth: 2560) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
  }
`
